export default __webpack_public_path__ + "static/media/laptop.67017e40.png";